/* Christina A11y runtime fixes (2026-06-15, rev3 — R6-W6 2026-08-04) — WCAG 2.2.
   1) focusable wewnątrz [aria-hidden="true"] -> tabindex="-1" (aria-hidden-focus)
   2) <img> w <video>/<video-media> bez alt -> alt="" (1.1.1 poster dekoracyjny)
   3) kontener z rolą wymagającą określonych dzieci, ale z GOŁYMI <button> (bez role) -> role="group"
      (naprawia .cca-segment / aria-required-children, NIE rusza prawdziwych tablist z role="tab").

   ─ rev3: TYLKO HARMONOGRAM, ZERO ZMIAN W `fix()` ────────────────────────────
   Ślad CDP (`traces\PRZED6-fn.json`) zmierzył `christina-a11y-runtime.js :: fix`
   na 92 ms (PDP mobile) i 108 ms (kolekcja mobile), a Lighthouse przypisywał tej
   funkcji zadania po 219 i 137 ms — bo `fix` je ROZPOCZYNAŁA, a resztę czasu
   zjadał w nich kod aplikacji. Trzy przyczyny, wszystkie w harmonogramie:

     · MutationObserver siedział na `document.documentElement` z `subtree: true`
       i budził się przy KAŻDEJ wstawce do dokumentu — także czysto tekstowej.
       Teraz: obserwuje `document.body` i ma wstępny filtr — jeśli w partii
       mutacji nie ma ani jednego DODANEGO ELEMENTU, kończy na jednym `if`.

     · Praca była planowana przez `setTimeout(…, 400)`, czyli zawsze zaczynała
       NOWE zadanie, niezależnie od tego, jak zajęty był wątek główny.
       Teraz: `requestIdleCallback` z limitem 1200 ms — ta sama praca ląduje
       w czasie bezczynności i nie przedłuża cudzych zadań. Limit gwarantuje,
       że przy stale obciążonym wątku poprawki i tak zostaną nałożone.

     · Dwa bezwarunkowe przebiegi (2 s, 5 s) też szły przez `setTimeout`.
       Teraz idą przez to samo planowanie bezczynnościowe.

   Zakres i treść poprawek pozostają identyczne — to jest warunek utrzymania
   wyniku Dostępność 100. Jeśli kiedykolwiek trzeba będzie ciąć dalej, ciąć
   częstotliwość, nigdy zakres selektorów. */
(function () {
  var ROLE_REQ = '[role="tablist"],[role="radiogroup"],[role="listbox"],[role="menu"]';
  function hasProperChild(c){
    return !!c.querySelector(':scope > [role="tab"], :scope > [role="radio"], :scope > [role="option"], :scope > [role="menuitem"], :scope > [role="menuitemradio"], :scope > [role="menuitemcheckbox"]');
  }
  function hasBareControl(c){
    return !!c.querySelector(':scope > button:not([role]), :scope > [tabindex]:not([role])');
  }
  function fix(root) {
    root = root || document;
    try {
      root.querySelectorAll('[aria-hidden="true"] a[href],[aria-hidden="true"] button,[aria-hidden="true"] input,[aria-hidden="true"] select,[aria-hidden="true"] textarea,[aria-hidden="true"] [tabindex]:not([tabindex="-1"])').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    } catch (e) {}
    try {
      root.querySelectorAll('video-media img:not([alt]),video img:not([alt])').forEach(function (img) { img.setAttribute('alt', ''); });
    } catch (e) {}
    try {
      root.querySelectorAll(ROLE_REQ).forEach(function (c) {
        if (!hasProperChild(c) && hasBareControl(c)) c.setAttribute('role', 'group');
      });
      root.querySelectorAll('.cca-segment').forEach(function (c) {
        if (c.getAttribute('role') && !hasProperChild(c) && c.querySelector('button')) c.setAttribute('role', 'group');
      });
    } catch (e) {}
  }

  /* Praca w czasie bezczynności — nie przedłuża zadania, które ją zaplanowało. */
  var czeka = false;
  function fixSoon() {
    if (czeka) return;
    czeka = true;
    var uruchom = function () { czeka = false; fix(document); };
    var r = window.requestIdleCallback;
    if (r) { try { r(uruchom, { timeout: 1200 }); return; } catch (e) {} }
    setTimeout(uruchom, 400);
  }

  if (document.readyState !== 'loading') fix(); else document.addEventListener('DOMContentLoaded', function () { fix(); });

  try {
    var mo = new MutationObserver(function (recs) {
      /* Wstępny filtr: bez dodanych ELEMENTÓW nie ma czego naprawiać. */
      for (var i = 0; i < recs.length; i++) {
        var add = recs[i].addedNodes;
        for (var j = 0; j < add.length; j++) {
          if (add[j].nodeType === 1) { fixSoon(); return; }
        }
      }
    });
    var korzen = document.body || document.documentElement;
    mo.observe(korzen, { childList: true, subtree: true });
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function () {
        try { mo.disconnect(); mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
      }, { once: true });
    }
  } catch (e) {}

  setTimeout(fixSoon, 2000);
  setTimeout(fixSoon, 5000);
})();
